import React from 'react';
import Dashboard from './components/Dashboard';

const App = () => {
	return <Dashboard />;
};
export default App;
